export class StringReplacerUtil {
  private static _instance: StringReplacerUtil;

  static get instance(): StringReplacerUtil {
    if (!StringReplacerUtil._instance) {
      StringReplacerUtil._instance = new StringReplacerUtil();
    }
    return StringReplacerUtil._instance;
  }

  replace(str: string, values: Record<string, string>): string {
    for (const [search, replacement] of Object.entries(values)) {
      str = str.replace(new RegExp(`{{${search}}}`, 'g'), replacement);
    }
    return str;
  }
}

export const getStringReplacerUtil = (): StringReplacerUtil => StringReplacerUtil.instance;
